import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import type * as Highcharts from 'highcharts';
import { HighchartsChartComponent, providePartialHighcharts } from 'highcharts-angular';

import { ROOM_UTILIZATION_ESTIMATED_TOOLTIP } from './room-utilization-charts';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.title]': '""',
  },
  imports: [HighchartsChartComponent, MatIcon, MatTooltip],
  providers: [providePartialHighcharts({})],
  selector: 'avs-room-utilization-bar-chart',
  templateUrl: './room-utilization-bar-chart.component.html',
})
export class RoomUtilizationBarChartComponent {
  chartOptions = input.required<Highcharts.Options>();
  estimated = input(false);
  statusAtEnd = input(false);
  title = input<string>();
  trackedWith = input<null | string>(null);

  protected readonly estimatedTooltip = ROOM_UTILIZATION_ESTIMATED_TOOLTIP;
}
